import { render, staticRenderFns } from "./Folha.vue?vue&type=template&id=03c0f00c&scoped=true&"
var script = {}
import style0 from "./Folha.vue?vue&type=style&index=0&id=03c0f00c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c0f00c",
  null
  
)

export default component.exports